<script>
export default {
  name: 'AmpliarIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24,
    },
    color: {
      type: String,
      default: '#030309',
    },
  },
}
</script>

<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5.33333 1C5.33333 0.447715 4.88562 0 4.33333 0H0V1.33333V2V4.33333C0 4.88562 0.447715 5.33333 1 5.33333C1.55228 5.33333 2 4.88562 2 4.33333V2L4.33333 2C4.88562 2 5.33333 1.55228 5.33333 1Z"
      :fill="color"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M15 5.33333C15.5523 5.33333 16 4.88562 16 4.33333L16 0L14.6667 -5.82819e-08L14 -8.74228e-08L11.6667 -1.89416e-07C11.1144 -2.13557e-07 10.6667 0.447715 10.6667 1C10.6667 1.55228 11.1144 2 11.6667 2L14 2L14 4.33333C14 4.88562 14.4477 5.33333 15 5.33333Z"
      :fill="color"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10.6667 15C10.6667 15.5523 11.1144 16 11.6667 16L16 16L16 14.6667L16 14L16 11.6667C16 11.1144 15.5523 10.6667 15 10.6667C14.4477 10.6667 14 11.1144 14 11.6667L14 14L11.6667 14C11.1144 14 10.6667 14.4477 10.6667 15Z"
      :fill="color"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M1 10.6667C0.447715 10.6667 6.40673e-07 11.1144 5.6825e-07 11.6667L0 16L1.33333 16L2 16L4.33333 16C4.88562 16 5.33333 15.5523 5.33333 15C5.33333 14.4477 4.88562 14 4.33333 14L2 14L2 11.6667C2 11.1144 1.55228 10.6667 1 10.6667Z"
      :fill="color"
    />
  </svg>
</template>
